import React, {
  useState,
} from "react";

import InventoryDashboard from "./Dashboard/InventoryDashboard";
import CategoryManagement from "./Categories/CategoryManagement";
import ProductManagement from "./Products/ProductManagement";
import StockManagement from "./Stock/StockManagement";

import InventoryTabs from "./shared/InventoryTabs";

import "./InventoryManagement.css";

const InventoryManagement = () => {
  const [activeTab, setActiveTab] =
    useState("dashboard");

  const renderActiveModule = () => {
    switch (activeTab) {
      case "dashboard":
        return (
          <InventoryDashboard />
        );

      case "categories":
        return (
          <CategoryManagement />
        );

      case "products":
        return (
          <ProductManagement />
        );

      case "stock":
        return (
          <StockManagement />
        );

      default:
        return (
          <InventoryDashboard />
        );
    }
  };

  return (

      <div className="inventory-page">
        <div className="inventory-header">
          <div>
            <span className="inventory-header-label">
              COMKWIK INVENTORY
            </span>

            <h2>
              Inventory Management
            </h2>

            <p>
              Manage categories, products,
              pricing, stock and inventory
              movements from one place.
            </p>
          </div>
        </div>

        <InventoryTabs
          activeTab={activeTab}
          onChange={setActiveTab}
        />

        <div className="inventory-body">
          {renderActiveModule()}
        </div>
      </div>
  );
};

export default InventoryManagement;